import * as React from "react"
import { Modal, Button, Container, Col, Row, Form } from "react-bootstrap"
import { FaAngleDown, FaLevelUpAlt } from "react-icons/fa"
import { Typeahead } from "react-bootstrap-typeahead"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { Subscription } from "rxjs"
import LabServiceRegulatoryModesGetObservable from "../../../api/LabService/LabServiceRegulatoryModesGet"
import RegulatoryMode from "../../../api/LabService/LabServiceModel/RegulatoryMode"
import EmployeeCategoriesGetObservable from "../../../api/LabService/EmployeeCategoriesGet"
import EmployeeCategory from "../../../api/LabService/LabServiceModel/EmployeeCategory"
import { RegMode } from "../../../api/OrderResults/OrderResultModel/GeneralInformation"
import { toast } from "react-toastify"
import FormatError from "../../../formatters/FormatError"

interface EmployeeRegModeModalProps {
  show: boolean
  selectedRegulatoryModes: RegMode[]

  accountType: string
  onSave: (regulatoryModes: RegMode[]) => void
  onClose: () => void
}

interface EmployeeRegModeModalState {
  availableRegulatoryModes?: RegulatoryMode[]
  isRegulatoryModesLoading: boolean
  selectedRegulatoryModes: RegMode[]
  availableCategories?: EmployeeCategory[]
  isCategoriesLoading: boolean
  regulatoryModes: RegMode[]
}
function createRegulatoryModes(selectedRegulatoryModes: RegMode[], items_count: number) {
  const regulatoryModes: RegMode[] = []
  const selectedLength = selectedRegulatoryModes.length
  for (let i = 0; i < items_count; i++) {
    if (i < selectedLength) {
      regulatoryModes[i] = copyRegMode(selectedRegulatoryModes[i])
    }
    else {
      regulatoryModes[i] = createEmptyRegMode()
    }
  }
  return regulatoryModes
}
function createEmptyRegulatoryMode() {
  const result: RegulatoryMode = {
    RegulatoryModeID: -1,
    Name: "",
    DOT: false,
    BeginEffectiveDate: "",
    EndEffectiveDate: "",
    UserLogin: "",
    UpdateDate: ""
  }
  return result
}
function createEmptyRegMode() {
  const result: RegMode = {
    EmpCat: "",
    EmployeeCategoryID: -1,
    PersonRegModeEmpCatID: 0,
    Primary: false,
    RegMode: "",
    RegulatoryModeID: -1
  }
  return result
}
function createRegMode(src: RegulatoryMode) {
  const result: RegMode = createEmptyRegMode()
  if (!src) {
    return result
  }
  result.RegulatoryModeID = src.RegulatoryModeID
  result.RegMode = src.Name
  return result
}
function copyRegMode(src: RegMode) {
  if (src) {
    return { ...src }
  }
  return createEmptyRegMode()
}
function createEmptyEmployeeCategory(regulatoryModeId: number) {
  const result: EmployeeCategory = {
    EmployeeCategoryID: -1,
    Code: "",
    Name: "",
    RegulatoryModeID: regulatoryModeId,
    BeginEffectiveDate: "",
    EndEffectiveDate: "",
    UserLogin: "",
    UpdateDate: ""
  }
  return result
}

export default class EmployeeRegModeModal extends React.Component<EmployeeRegModeModalProps, EmployeeRegModeModalState> {
  ITEMS_COUNT: number = (this.props.selectedRegulatoryModes.length > 5 ? this.props.selectedRegulatoryModes.length : 5)
  state: EmployeeRegModeModalState = {
    isRegulatoryModesLoading: false,
    selectedRegulatoryModes: this.props.selectedRegulatoryModes,
    isCategoriesLoading: false,
    regulatoryModes: createRegulatoryModes(this.props.selectedRegulatoryModes, this.ITEMS_COUNT)
  }

  subscriptions = new Subscription()
  regulatoryModeTypeaheads: React.RefObject<Typeahead<RegulatoryMode>>[] = []
  categoryTypeaheads: React.RefObject<Typeahead<EmployeeCategory>>[] = []
  regulatoryModes: RegMode[] = []

  componentDidMount() {
    this.createTypeaheads()
    this.setState({isRegulatoryModesLoading: true, isCategoriesLoading: true})
    this.subscriptions.add(LabServiceRegulatoryModesGetObservable().subscribe(
      (data: RegulatoryMode[]) => {
        if(data.length > 0){
          const item = createEmptyRegulatoryMode()
          data.unshift(item)
        }
        this.setState({
          availableRegulatoryModes: data,
          isRegulatoryModesLoading: false
        })
      },
      (error) => {
        toast.error(FormatError(error)),
        this.setState({ isRegulatoryModesLoading: false })
      }
    ))

    this.subscriptions.add(EmployeeCategoriesGetObservable().subscribe(
      (data: EmployeeCategory[]) => {
        this.setState({
          availableCategories: data,
          isCategoriesLoading: false
        })
      },
      (error) => {
        toast.error(FormatError(error)),
        this.setState({ isCategoriesLoading: false })
      }
    ))



  }

  componentWillUnmount() {
    this.subscriptions.unsubscribe()
  }
  createTypeaheads() {
    this.regulatoryModeTypeaheads = []
    this.categoryTypeaheads = []
    for (let i = 0; i < this.ITEMS_COUNT; i++) {
      const regulatoryModeTypeahead = React.createRef<Typeahead<RegulatoryMode>>()
      const categoryTypeahead = React.createRef<Typeahead<EmployeeCategory>>()
      this.regulatoryModeTypeaheads[i] = regulatoryModeTypeahead
      this.categoryTypeaheads[i] = categoryTypeahead
    }
  }
  componentDidUpdate(prevProps: EmployeeRegModeModalProps, prevState: EmployeeRegModeModalState) {
    if (!(this.isRegulatoryModesEqual(this.props.selectedRegulatoryModes, prevProps.selectedRegulatoryModes))) {
      this.setState({
        selectedRegulatoryModes: this.props.selectedRegulatoryModes,
        regulatoryModes: createRegulatoryModes(this.props.selectedRegulatoryModes, this.ITEMS_COUNT)
      })
    }
  }


  isRegulatoryModesEqual = (items1: RegMode[], items2: RegMode[]) => {
    const itemsString = (items: RegMode[]) => items.map(item => item.RegulatoryModeID).sort().join(",")
    return itemsString(items1) === itemsString(items2)
  }


  handleSave = () => {
    const regulatoryModes = this.state.regulatoryModes || []
    for(let i = 0; i < regulatoryModes.length; i++){
      if(regulatoryModes[i].RegulatoryModeID < 0)
      {
        regulatoryModes[i].RegulatoryModeID = 0
        regulatoryModes[i].EmployeeCategoryID = 0
      }
      if(regulatoryModes[i].EmployeeCategoryID < 0)
      {
        regulatoryModes[i].EmployeeCategoryID = 0
      }
    }
    this.props.onSave(regulatoryModes)
  }

  handleClose = () => {
    this.setState({
      selectedRegulatoryModes: this.props.selectedRegulatoryModes
    })
    this.props.onClose()
  }



  handleChangeRegulatoryMode = (item: RegulatoryMode, inputIndex: number) => {
    const regulatoryModes = this.state.regulatoryModes || []
    if (inputIndex < 0) {
      return
    }
    if (inputIndex >= regulatoryModes.length) {
      return
    }
    regulatoryModes[inputIndex].RegulatoryModeID = item.RegulatoryModeID
    regulatoryModes[inputIndex].RegMode = item.Name
    this.setState({ regulatoryModes: regulatoryModes })

  }


  handleChangeCategory = (item: EmployeeCategory, inputIndex: number) => {
    const regulatoryModes = this.state.regulatoryModes || []
    if (inputIndex < 0) {
      return
    }
    if (inputIndex >= regulatoryModes.length) {
      return
    }
    regulatoryModes[inputIndex].EmployeeCategoryID = item.EmployeeCategoryID
    regulatoryModes[inputIndex].EmpCat = item.Name
    this.setState({ regulatoryModes: regulatoryModes })
  }

  handleChangePrimary = (inputIndex: number) => {
    const regulatoryModes = this.state.regulatoryModes || []
    for(let i = 0; i < regulatoryModes.length; i++){
      regulatoryModes[i].Primary = ((i === inputIndex) && (regulatoryModes[i].RegulatoryModeID >= 0))
    }
    this.setState({ regulatoryModes: regulatoryModes })
  }
  createRow = (itemIndex: number) => {
    const regulatoryModes = this.state.regulatoryModes || []
    const allRegulatoryModes = this.state.availableRegulatoryModes || []
    if ((regulatoryModes.length === 0) || (allRegulatoryModes.length === 0)) {
      return <></>
    }
    const disabled = this.state.isRegulatoryModesLoading || this.state.isCategoriesLoading
    const regulatoryModeTypeahead = this.regulatoryModeTypeaheads[itemIndex]
    const categoryTypeahead = this.categoryTypeaheads[itemIndex]
    const regMode = regulatoryModes[itemIndex]
    const regModeId = regMode.RegulatoryModeID
    const regulatoryModeIndex = allRegulatoryModes.findIndex(item => item.RegulatoryModeID === regModeId)
    const regulatoryMode = (regulatoryModeIndex >= 0) ? allRegulatoryModes[regulatoryModeIndex] : createEmptyRegulatoryMode()
    const allEmployeeCategories = this.state.availableCategories || []

    const employeeCategories = allEmployeeCategories.filter(item => item.RegulatoryModeID === regModeId)
    if(employeeCategories.length > 0){
      const item = createEmptyEmployeeCategory(regModeId)
      employeeCategories.unshift(item)
    }
    const employeeCategoryId = regMode.EmployeeCategoryID
    const employeeCategoryIndex = employeeCategories.findIndex(item => item.EmployeeCategoryID === employeeCategoryId);
    const employeeCategory = (employeeCategoryIndex >= 0) ? employeeCategories[employeeCategoryIndex] : createEmptyEmployeeCategory(regModeId)
    return <Row>
      <Col md={5}>
        <div className="typeahead">
          <Typeahead id={"regMode_" + itemIndex}
            ref={regulatoryModeTypeahead}
            labelKey={(option) => (option.RegulatoryModeID >= 0) ? `${option.Name}` : "Regulatory Mode"}
            filterBy={(option, props) => {
              return props.selected.length > 0 ;
            }}
            onChange={selected => this.handleChangeRegulatoryMode(selected[0], itemIndex)}
            disabled={disabled}
            options={(allRegulatoryModes)}
            selected={[regulatoryMode]}
            emptyLabel="No Result Found"
            placeholder="Regulatory Mode">
            <Button variant="toggle" onClick={() => { regulatoryModeTypeahead && regulatoryModeTypeahead.current && (regulatoryModeTypeahead.current as any).toggleMenu() }}>
              <FaAngleDown />
            </Button>
          </Typeahead>
        </div>
      </Col>
      <Col md={5}>
        <div className="typeahead">
          <Typeahead id={"category_" + itemIndex}
            ref={categoryTypeahead}
            labelKey={(option) => (option.EmployeeCategoryID >= 0) ? `${option.Name} (${option.Code})` : "Category"}
            filterBy={(option, props) => {
              return props.selected.length > 0;
            }}
            onChange={selected => this.handleChangeCategory(selected[0], itemIndex)}
            disabled={disabled}
            options={employeeCategories}
            selected={[employeeCategory]}
            emptyLabel="No Result Found"
            placeholder="Category">
            <Button variant="toggle" onClick={() => { categoryTypeahead && categoryTypeahead.current && (categoryTypeahead.current as any).toggleMenu() }}>
              <FaAngleDown />
            </Button>
          </Typeahead>
        </div>
      </Col>
      <Col md={1}>
        <Form.Check
          type="radio"
          //inline 
          id={"is_primary_mode_" + itemIndex}
          name={"is_primary_mode"}
          label="" 
          checked={regMode.Primary && regMode.RegulatoryModeID >= 0}
          disabled={disabled && regMode.RegulatoryModeID >= 0}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleChangePrimary(itemIndex)}
          className="abc-radio abc-radio-primary" />
      </Col>
    </Row>

  }

  render() {

    const { selectedRegulatoryModes } = this.state
    const rows = []
    for (let i = 0; i < this.ITEMS_COUNT; i++) {
      rows[i] = this.createRow(i)
    }
    return <Modal backdrop="static" size="lg" centered show={this.props.show} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>REGULATORY ASSIGNMENTS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row>
            <Col md={5}>Regulatory Mode</Col>
            <Col md={5}>Category</Col>
            <Col md={1}>Primary</Col>
          </Row>
          {rows}
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleClose}>CANCEL</Button>
        <Button variant="primary" onClick={() => this.handleSave()}>APPLY</Button>
      </Modal.Footer>
    </Modal >
  }
}
